// extracted by mini-css-extract-plugin
module.exports = {"meta":"event-meta-module--meta--3b8xK"};